"use client";

import { useState } from "react";
import { CitizenForm } from "@/components/citizens/CitizenForm";
import { CitizensAPI } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function NewCitizenPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      const submitData = {
        ...data,
        is_verified: true,
      };
      const response = await CitizensAPI.create(submitData);
      toast.success("Citizen created successfully");
      navigate(`/citizens/${response.citizen.citizen_id}`);
    } catch (error) {
      console.error("Error creating citizen:", error);
      toast.error("Failed to create citizen");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Add New Citizen</h1>
        <p className="text-muted-foreground">
          Create a new citizen profile in the system
        </p>
      </div>

      <div className="rounded-lg border p-6">
        <CitizenForm
          onSubmit={handleSubmit}
          isLoading={isLoading}
          isNewCitizen={true}
        />
      </div>
    </div>
  );
}
